@switch (layer().layerType) {

@case (LayerType.BackgroundImage) {
<div class="layer layer--image" [class.layer--anchored]="isAnchored()" [ngStyle]="positionStyles()"
    [style.background-image]="'url(' + layer().imageUrl + ')'">
</div>
}

@case (LayerType.TextOverlay) {
<div class="layer layer--text" [class.layer--anchored]="isAnchored()" [ngStyle]="positionStyles()"
    [style.font-size]="layer().style?.fontSize" [style.color]="layer().style?.color"
    [style.font-weight]="layer().style?.fontWeight" [style.text-align]="layer().style?.textAlign"
    [style.font-family]="layer().style?.fontFamily"
    [style.background-color]="layer().style?.backgroundColor">{{ displayText() }}</div>
}

@case (LayerType.ComponentWidget) {
<div class="layer layer--widget" [class.layer--anchored]="isAnchored()" [ngStyle]="positionStyles()">
    <!-- QR widgets (payment / receipt). Any other componentType still renders an empty box. -->
    @if (qrData(); as qrUrl) {
    <qrcode [qrdata]="qrUrl" [width]="qrWidth()" [errorCorrectionLevel]="'M'" [margin]="1" [colorDark]="'#000000'"
        [colorLight]="'#FFFFFF'" elementType="canvas" alt="Payment QR code"></qrcode>
    }
</div>
}

}